export enum NotificationTypes {
    default = "default",
    success = "success",
    error = "error",
    info = "info",
}
